export function StageEditorShell() {
  return (
    <>
      <div className="editor-body">
        <section className="panel is-on" data-panel="map">
          <p className="hint" id="hint" />
          <p className="map-issues" id="map-issues" hidden />
          <div className="map-scroll">
            <div className="map-wrap" id="map-wrap">
              <svg className="editor-lines" id="lines" />
              <svg className="editor-stretch" id="stretch" />
              <div className="grid" id="grid" />
            </div>
          </div>
          <button type="button" className="add-row" id="add-row">下に行を足す</button>
          <button type="button" className="trash" id="trash">捨てる（ここにドロップ）</button>
          <div className="palette" id="palette" />
          <div className="sheet" id="sheet" hidden>
            <div className="sheet-head">
              <h3 id="sheet-title">案件</h3>
              <button type="button" className="sheet-close" id="sheet-close">閉じる</button>
            </div>
            <div id="case-fields">
              <div className="field">
                <label htmlFor="case-size">規模</label>
                <select id="case-size">
                  <option value="small">small</option>
                  <option value="medium">medium</option>
                  <option value="large">large</option>
                  <option value="boss">boss</option>
                </select>
              </div>
              <div className="nums">
                <div className="field">
                  <label htmlFor="req">必要進捗</label>
                  <input id="req" type="number" />
                </div>
                <div className="field">
                  <label htmlFor="dl">工期</label>
                  <input id="dl" type="number" />
                </div>
              </div>
              <div className="field">
                <label>負荷</label>
                <div id="load-list" />
                <div className="load-add">
                  <select id="load-pick" />
                  <button type="button" id="load-add">足す</button>
                </div>
              </div>
              <div className="field">
                <label htmlFor="case-name">名前</label>
                <input id="case-name" />
              </div>
              <div className="field">
                <label htmlFor="flavor">フレーバー</label>
                <textarea id="flavor" rows={2} />
              </div>
            </div>
          </div>
        </section>
        <section className="panel" data-panel="reward">
          <p className="hint">カードをタップでオンオフ。全部オフなら共通プール。</p>
          <div id="reward-pools" />
        </section>
        <section className="panel" data-panel="start">
          <div className="field">
            <label htmlFor="st-name">ステージ名</label>
            <input id="st-name" />
          </div>
          <div className="field">
            <label htmlFor="st-diff">難易度ラベル</label>
            <input id="st-diff" />
          </div>
          <div className="field">
            <label htmlFor="st-flavor">フレーバー</label>
            <textarea id="st-flavor" rows={2} />
          </div>
          <div className="step" data-step data-deck="intern">
            <span>新卒</span>
            <span><button type="button" data-minus>−</button> <span data-count>7</span> <button type="button" data-plus>＋</button></span>
          </div>
          <div className="step" data-step data-deck="idle">
            <span>窓際</span>
            <span><button type="button" data-minus>−</button> <span data-count>3</span> <button type="button" data-plus>＋</button></span>
          </div>
          <div className="step" data-step data-deck="hedge">
            <span>リスクヘッジ</span>
            <span><button type="button" data-minus>−</button> <span data-count>0</span> <button type="button" data-plus>＋</button></span>
          </div>
          <label className="toggle">持ち込みを許可する <input id="st-bring-in" type="checkbox" /></label>
        </section>
      </div>
      <nav className="editor-tabs">
        <button type="button" className="editor-tab is-on" data-tab="map">マップ</button>
        <button type="button" className="editor-tab" data-tab="reward">報酬</button>
        <button type="button" className="editor-tab" data-tab="start">山札</button>
      </nav>
    </>
  );
}
